import React from 'react';
import { ArrowUpRightIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface MarketItem {
  title: string;
  subtitle: string;
  price: string;
  changePercent: string;
  isNegative: boolean;
  sparklinePath: string;
  sparklineFill: string;
}
const marketItems: MarketItem[] = [{
  title: 'Choice Cutout',
  subtitle: 'Beef',
  price: '$388.37',
  changePercent: '+0.27%',
  isNegative: false,
  sparklinePath: 'M2,26 L8,24 L14,25 L20,22 L26,20 L32,21 L38,18 L44,16 L50,17 L56,14 L62,12 L68,10 L74,8 L80,7 L86,6 L90,5',
  sparklineFill: 'M2,26 L8,24 L14,25 L20,22 L26,20 L32,21 L38,18 L44,16 L50,17 L56,14 L62,12 L68,10 L74,8 L80,7 L86,6 L90,5 L90,32 L2,32 Z'
}, {
  title: 'Select Cutout',
  subtitle: 'Beef',
  price: '$388.04',
  changePercent: '+0.60%',
  isNegative: false,
  sparklinePath: 'M2,24 L10,23 L18,24 L26,22 L34,21 L42,20 L50,18 L58,16 L66,14 L74,10 L82,8 L90,6',
  sparklineFill: 'M2,24 L10,23 L18,24 L26,22 L34,21 L42,20 L50,18 L58,16 L66,14 L74,10 L82,8 L90,6 L90,32 L2,32 Z'
}, {
  title: 'CH/SEL Spread',
  subtitle: 'Beef',
  price: '$-0.33',
  changePercent: '+290.91%',
  isNegative: true,
  sparklinePath: 'M2,10 L8,12 L14,14 L20,16 L26,14 L32,18 L38,20 L44,22 L50,18 L56,20 L62,24 L68,22 L74,26 L80,24 L86,28 L90,26',
  sparklineFill: 'M2,10 L8,12 L14,14 L20,16 L26,14 L32,18 L38,20 L44,22 L50,18 L56,20 L62,24 L68,22 L74,26 L80,24 L86,28 L90,26 L90,32 L2,32 Z'
}, {
  title: 'Pork Cutout',
  subtitle: 'Pork',
  price: '$99.04',
  changePercent: '+0.45%',
  isNegative: false,
  sparklinePath: 'M2,18 L8,16 L14,18 L20,14 L26,16 L32,12 L38,14 L44,10 L50,12 L56,8 L62,10 L68,8 L74,6 L80,8 L86,6 L90,5',
  sparklineFill: 'M2,18 L8,16 L14,18 L20,14 L26,16 L32,12 L38,14 L44,10 L50,12 L56,8 L62,10 L68,8 L74,6 L80,8 L86,6 L90,5 L90,32 L2,32 Z'
}];
function Sparkline({
  item
}: {
  item: MarketItem;
}) {
  const strokeColor = item.isNegative ? '#b91c1c' : '#166534';
  const fillColor = item.isNegative ? 'rgba(185,28,28,0.08)' : 'rgba(22,101,52,0.08)';
  return <svg width="80" height="32" viewBox="0 0 92 32" fill="none" className="flex-shrink-0" data-id="element-291">
      <path d={item.sparklineFill} fill={fillColor} data-id="element-292" />
      <path d={item.sparklinePath} stroke={strokeColor} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-293" />
      {/* Dot at end */}
      <circle cx="90" cy={item.sparklinePath.split(' ').pop()?.split(',')[1] || '5'} r="2.5" fill={strokeColor} data-id="element-294" />
      {/* Dotted baseline */}
      <line x1="2" y1="31" x2="90" y2="31" stroke="#d1d5db" strokeWidth="1" strokeDasharray="2 2" data-id="element-295" />
    </svg>;
}
export function SidebarMarketWidget() {
  return <div className="bg-[#f0f0f0] rounded-xl p-4 mb-8" data-id="element-296">
      {/* Header */}
      <div className="flex items-start justify-between mb-4" data-id="element-297">
        <div data-id="element-298">
          <h3 className="text-xs font-bold text-gray-800 uppercase tracking-[0.2em]" data-id="element-299">
            USDA Market Pulse
          </h3>
          <div className="flex items-center gap-1.5 mt-1.5" data-id="element-300">
            <span className="text-[11px] text-gray-600" data-id="element-301">
              Powered by{' '}
              <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="font-semibold text-[#002f5f] hover:underline" data-id="element-302">
                MeatMarket.AI
              </a>
            </span>
          </div>
        </div>
        <a href="/market-iq/beef" className="inline-flex items-center gap-1 text-xs font-semibold text-[#002f5f] hover:underline transition-colors" data-id="element-303">
          Launch Market-IQ
          <ArrowUpRightIcon className="w-3 h-3" data-id="element-304" />
        </a>
      </div>

      {/* Market Cards */}
      <div className="flex flex-col gap-3" data-id="element-305">
        {marketItems.map((item, idx) => <a key={idx} href="/market-iq" className="bg-white rounded-lg border border-gray-200 px-4 py-3 flex items-center justify-between hover:border-gray-300 transition-colors" data-id="element-306">
            {/* Left: Title + Subtitle */}
            <div className="flex flex-col min-w-0" data-id="element-307">
              <span className="text-sm font-bold text-gray-900 leading-tight" data-id="element-308">
                {item.title}
              </span>
              <span className="text-xs text-gray-500 mt-0.5" data-id="element-309">
                {item.subtitle}
              </span>
            </div>

            {/* Center: Sparkline */}
            <div className="mx-3 flex-shrink-0" data-id="element-310">
              <Sparkline item={item} data-id="element-311" />
            </div>

            {/* Right: Price + Change */}
            <div className="flex flex-col items-end flex-shrink-0" data-id="element-312">
              <span className="text-lg font-bold text-gray-900 leading-tight" data-id="element-313">
                {item.price}
              </span>
              <span className={`text-xs font-medium flex items-center gap-0.5 mt-0.5 ${item.isNegative ? 'text-red-700' : 'text-green-800'}`} data-id="element-314">
                {item.isNegative ? <TrendingDownIcon className="w-3 h-3" data-id="element-315" /> : <TrendingUpIcon className="w-3 h-3" data-id="element-316" />}
                {item.changePercent}
              </span>
            </div>
          </a>)}
      </div>
    </div>;
}